export default {
  'zh-CN': {
    home: '首页',
    switchLangTitle: '切换语言',
    i18n: '多语言切换',
  },
  'zh-TW': {
    home: '首頁',
    switchLangTitle: '切換語言',
    i18n: '多語言切換',
    
  },
  'en-US': {
    home: 'home',
    switchLangTitle: 'Switch Lang',
    i18n: 'Switch Lang'
  }
}
